import { Search, Car, MapPin, Home, ArrowLeft } from "lucide-react";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-lg w-full bg-white rounded-lg shadow-xl p-8 text-center">
        {/* Automotive-themed 404 illustration */}
        <div className="relative mb-8">
          <div className="mx-auto w-32 h-32 bg-blue-100 rounded-full flex items-center justify-center relative">
            <Car className="w-16 h-16 text-blue-600" />
            <div className="absolute -top-2 -right-2 bg-orange-500 text-white rounded-full w-8 h-8 flex items-center justify-center">
              <Search className="w-4 h-4" />
            </div>
          </div>
          <div className="flex justify-center mt-4">
            <MapPin className="w-9 h-9 text-gray-400 mr-2" />
            <span className="text-4xl font-bold text-gray-800">404</span>
          </div>
        </div>

        {/* Error message */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Route Not Found
        </h1>
        <p className="text-gray-600 mb-2">
          Looks like this destination doesn&apos;t exist in our system.
        </p>
        <p className="text-gray-500 mb-8 text-sm">
          The page you&apos;re looking for might have been moved, deleted, or doesn&apos;t exist.
        </p>


        {/* Action buttons */}
        <div className="flex gap-3 justify-center">
          <Button
            onClick={handleGoBack}
            variant="outline"
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </Button>
          <Button
            onClick={handleGoHome}
            variant="default"
            className="flex items-center gap-2"
          >
            <Home className="w-4 h-4" />
            Dashboard
          </Button>
        </div>

        {/* Automotive-themed footer */}
        <div className="mt-8 pt-4 border-t border-gray-200">
          <p className="text-xs text-gray-500">
            🛣️ Auttom - Navigate your automotive business with confidence
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;